import gql from 'graphql-tag';

export const EXPORT_COMMISSIONS = gql`
  mutation exportCommissions($type: CommissionStatus!, $startDate: Date!, $endDate: Date!) {
    exportCommissions(type: $type, startDate: $startDate, endDate: $endDate)
  }
`;
